import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=99df7c02"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99df7c02')) {
      api.createRecord('99df7c02', component.options)
    } else {
      api.reload('99df7c02', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=99df7c02", function () {
      api.rerender('99df7c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/Layout.vue"
export default component.exports